import { WishlistLineItem } from '@api/types';
import { TextCodes } from '@api/types/translation/TextCodes';
import {
  Image,
  OrderBox,
  OrderItemWrapper,
  QuantitySelector,
  SmartLink,
  Title,
  WishlistToggle,
} from '@components';
import { useWishlistItem } from '@hooks';
import { AddShoppingCart } from '@mui/icons-material';
import { Box, Grid, IconButton, Stack } from '@mui/material';
import { colors } from '@themes/colors';
import { t } from '@translations';
import { formatPrice } from '@utils/price.utils';

export type MobileWishlistLineItemProps = {
  lineItem?: WishlistLineItem;
};

export const MobileWishlistLineItem = ({ lineItem = {} }: MobileWishlistLineItemProps) => {
  const { name, productNo = '', quantity = 0, url } = lineItem;

  const {
    resizedImageUrl,
    localQuantity,
    setLocalQuantityHandler,
    addToCartHandler,
    isAddToCartWorking,
    itemPrice,
    totalItemPrice,
  } = useWishlistItem(lineItem);
  return (
    <Box sx={{ display: { xs: 'block', lg: 'none' }, height: '100%' }}>
      <OrderBox sx={{ height: '100%' }}>
        <OrderItemWrapper>
          <Grid container>
            <Grid item xs={3} sx={{ lineHeight: 0, pr: 2 }}>
              <Image
                image={resizedImageUrl}
                resizerParams={{ width: 100, format: 'webp' }}
                width='100'
                height='100'
              />
            </Grid>
            <Grid item xs={9}>
              <Box display='flex' flexDirection='column' height='100%' alignItems='left'>
                <Stack spacing={0.25} mb={2}>
                  <SmartLink href={url}>
                    <Title variant='h6' noDot>
                      {name}
                    </Title>
                  </SmartLink>

                  <Box sx={{ width: { xs: 'min-content', sm: 'auto' }, mt: 2 }}>
                    {t(TextCodes.Product.Details.ProductNumber, { productNo })}
                  </Box>
                  <Box>
                    {quantity} x {formatPrice(itemPrice)} = {formatPrice(totalItemPrice)}
                  </Box>
                </Stack>
                <Stack mt='auto' gap={3} direction='row' flexWrap='wrap'>
                  <QuantitySelector
                    dark
                    quantity={localQuantity}
                    setQuantity={setLocalQuantityHandler}
                  />
                  <Stack direction='row' gap={2} alignItems='center' justifyContent='flex-end'>
                    <IconButton
                      onClick={addToCartHandler}
                      disabled={isAddToCartWorking}
                      sx={{ color: colors.primary.mainGreen }}
                    >
                      <AddShoppingCart />
                    </IconButton>

                    <WishlistToggle code={lineItem?.code || ''} hasRemoveIcon />
                  </Stack>
                </Stack>
              </Box>
            </Grid>
          </Grid>
        </OrderItemWrapper>
      </OrderBox>
    </Box>
  );
};
